<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
  <div>
    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span
            ><b-icon icon="reception3" aria-hidden="true"></b-icon
          ></span>
          <span>Bandeja de Medición (Indicador Avpt)</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Indicador_AVPT</div>
        </b-col>
      </b-row>

      <br/>
      <b-form  @submit.stop.prevent="handleSubmit(generar)" >
      <div class="row" >
        <b-col cols="4">
          <validation-provider v-if="$localStorageService.can('Indicadores_AVPT_fecha')" name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
            <label>Fecha inicio de aceptación de PTI:<validacion/></label>
            <b-input-group size="sm" class="mb-2">
              <b-form-datepicker placeholder="Fecha inicio"
                                 :max="new Date()"
                                 @input="fechaMaxima($event)"
              ></b-form-datepicker>
            </b-input-group>
            <b-form-invalid-feedback :state="filtro.fechaInicio != null">
              Este campo es obligatorio
            </b-form-invalid-feedback>
          </validation-provider>
        </b-col>

        <b-col cols="4">
          <validation-provider v-if="$localStorageService.can('Indicadores_AVPT_fecha')" name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
            <label>Fecha fin de aceptación de PTI:<validacion/></label>
            <b-input-group size="sm" class="mb-2">
              <b-form-datepicker placeholder="Fecha fin"
                                 v-model="filtro.fechaFin"
                                 :max="filtro.fechaInicio.addDays(diasMaximoMes) > new Date() ? new Date(): filtro.fechaInicio.addDays(diasMaximoMes)"
                                 :min="filtro.fechaInicio"
              ></b-form-datepicker>
            </b-input-group>
            <b-form-invalid-feedback :state="filtro.fechaFin != null">
              Este campo es obligatorio
            </b-form-invalid-feedback>
          </validation-provider>
        </b-col>

        <b-col cols="4">
          <b-button v-if="$localStorageService.can('Indicadores_AVPT_generar')" class="m-5" variant="outline-success"
                    @click="generarInformacion()"
                    :disabled="loader"
          > Generar
            <b-spinner v-if="loader" small></b-spinner>
            <b-icon v-else icon="check-circle" ></b-icon>
          </b-button>
        </b-col>
      </div>


        <div class="row">
          <b-col cols="12">
            <validation-provider name="clinica" :rules="{ required: true }" v-slot="validationContext">
              <label>Clínica(s):<validacion/></label>
              <b-container>
                <b-row style="width: 100%">
                  <b-col cols="10">
                    <v-select style="width: 100%" :clearable="false" :options="listaClinicas"
                              v-model="filtro.idsClinica"
                              :reduce="(variable) => variable.idClinica"
                              label="nombreClinica" placeholder="Selecciona una clínica" multiple>
                      <span slot="no-options">No hay clínicas disponibles</span>
                    </v-select>
                  </b-col>
                  <b-col cols="1">
                    <b-button v-if="!estanSeleccionadasClinicas && $localStorageService.can('Indicadores_AVPT_fecha') "
                        class="ml-1"
                        variant="outline-primary"
                        v-b-tooltip.hover
                        title="Seleccionar Todos"
                        @click="seleccionarTodasClinicas()">
                      <b-icon icon="check2-all"></b-icon>
                    </b-button>
                  </b-col>
                  <b-col cols="1">
                    <b-button v-if=" estanSeleccionadasClinicas || filtro.idsClinica.length > 0 && $localStorageService.can('Indicadores_AVPT_fecha')"
                        class="ml-1"
                        variant="outline-primary"
                        v-b-tooltip.hover
                        title="Quitar Todos"
                        @click="quitarTodasClinicas()">
                      <b-icon icon="x"></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </b-container>
              <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
            </validation-provider>
          </b-col>
        </div>
      </b-form>




      <div class="mt-2 col-md-12"></div> <br/>


      <b-row>
        <b-col cols="12">
          <b-table
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive
              class="parrafos">

          </b-table>
          <b-alert
              v-if="datosTabla.length === 0"
              show >No hay datos
          </b-alert>
            <b-spinner v-if="loader" ></b-spinner>

          <b-col >
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 20"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>



    </b-card>
  </div>
    <br/>
    <br/>

  </div>
</template>

<script>
import Header from "@/components/Header";
import { required } from "vuelidate/lib/validators";
export default {
  name: "MedicionIndicadorAvpt",
  components: { Header },
  data: () => (
      {
        version: process.env.VUE_APP_ENV_VERSION,
        debug: false,
        listaClinicas: [],
        estanSeleccionadasClinicas: false,
        fields: [],
        paginaActual: 1,
        datosTabla: [],
        loader: false,



        filtro: {
          fechaInicio: null,
          fechaFin: null,
          idsClinica: [],
        },

      }
  ),
  validations: {

    filtro: {
      fechaInicio: {required},
      fechaFin: {required},
      idsClinica: {required}
    }

  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.llenarClinicas();
  },

  methods: {
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;

    },

    llenarClinicas() {
      this.listaClinicas = this.$localStorageService.getClinicas();
    },

    seleccionarTodasClinicas() {
      this.listaClinicas.forEach(element => {
        this.filtro.idsClinica.push(element.idClinica);
      });
      this.estanSeleccionadasClinicas = true
    },

    quitarTodasClinicas() {
      this.filtro.idsClinica = [];
      this.estanSeleccionadasClinicas = false
    },

    generarInformacion(){
      this.datosTabla = [];
      this.loader = true;
      if (this.filtro.fechaInicio == null || this.filtro.fechaFin == null || this.filtro.idsClinica.length == 0) {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Todos los campos son obligatorios, por favor verifique la información",
        });

      }

      this.$http
          .post(this.$api +  "indicador-avpt/indicadorAvpt-datosBandeja?pagina=" + this.paginaActual, this.filtro )
          .then((response) => {
                if (response.data.data) {
                  this.datosTabla = response.data.data.datosBandejaIndicador;
                }

          }).finally(() => {
              this.loader = false;
          })
    },



    validateState(name) {
      const { $dirty, $error } = this.$v.sla[name];
      return $dirty ? !$error : null;
    },
  },
  mounted() {
    this.fields = [

      {key: "clinica", label: "Clínica", sortable: true},
      {key: "totalTxsAceptados", label: "# Tx Aceptados", sortable: true},
      {key: "totalTxsIniciados", label: "#Tx Aceptados iniciados", sortable: true},
      {key: "aceptados_Iniciados", label: "Iniciados / Aceptados", sortable: true},
      {key: "aceptadosProxCita", label: "#Tx Aceptados con próxima cita", sortable: true},
      {key: "aceptadosProxCita_Aceptados", label: "#Tx Aceptados con próxima cita / #TxAceptados", sortable: true},
    ];
  },
  watch: {

  }
};
</script>

<style scoped>


</style>
